<div class="modal-content">
  <div class="modal-header">
    <h3>{{configuration.header ? (configuration.header | translate) : configuration.headerText}}</h3>
    @if (configuration.isCrossClose) {
      <div class="modal-close">
        <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="activeModal.dismiss('closed')">
      </div>
    }
  </div>
  @if (configuration.isBody) {
    <div class="modal-body">
      <div class="modal-body-content">
        <ng-content></ng-content>
      </div>
    </div>
  }
  @if (configuration.isFooter) {
    <div class="modal-footer">
      <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
        @if (configuration.isCustom) {
          <button mat-stroked-button class="secondary" (click)="navigateTo(configuration.customAction)">{{configuration.customLabel | translate}}</button>
        }
        @if (configuration.isNo) {
          <button mat-stroked-button class="no" (click)="close(false)">{{configuration.noLabel | translate}}</button>
        }
        @if (configuration.isYes) {
          <button mat-stroked-button class="primary" (click)="close(true)">{{configuration.yesLabel | translate}}</button>
        }
        @if (configuration.isClose) {
          <button mat-stroked-button (click)="activeModal.dismiss('closed')">{{configuration.closeLabel | translate}}</button>
        }
      </div>
    </div>
  }
</div>
